import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iRenameLibraryState {
    group_name: string;
    current_name: string;
    new_name: string;
    isLoading: boolean;
    message: string | null;
    response: any[];
}


const initialState: iRenameLibraryState = {
    group_name: "",
    current_name: "",
    new_name: "",
    isLoading: false,
    message: "",
    response: [],
};

// Rename Library API 호출
export const renameLibraryAPI = createAsyncThunk(
    "RENAME_LIBRARY",
    async (params: { group_name: string; current_name: string; new_name: string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/library/rename/';
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                group_name: params.group_name,
                current_name: params.current_name,
                new_name: params.new_name,
            }, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// Rename Library Slice
export const renameLibrarySlice = createSlice({
    name: "renameLibrary",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(renameLibraryAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(renameLibraryAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(renameLibraryAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    },
});

export default renameLibrarySlice.reducer;